<template>
  <div class="mod-simple-pagination">
    <a-button :size="size" :disabled="disabled || current === 1" icon="left" @click="onPrev"></a-button>
    <a-button :size="size" :disabled="disabled || total === current" icon="right" @click="onNext"></a-button>
  </div>
</template>

<script>
export default {
  name: 'simple-pagination',
  props: {
    current: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    disabled: Boolean,
    pageSize: {
      type: Number,
      default: 10
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    onPrev () {
      this.$emit('change', {
        current: this.current - 1,
        pageSize: this.pageSize
      })
    },
    onNext () {
      this.$emit('change', {
        current: this.current + 1,
        pageSize: this.pageSize
      })
    }
  }
}
</script>
